// extracted by mini-css-extract-plugin
module.exports = {"title":"LoyaltyReferralCode_title__TVQpI","subTitle":"LoyaltyReferralCode_subTitle__gNjyf","formWrapper":"LoyaltyReferralCode_formWrapper__my0Sb"};